var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgExpand = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 280 280"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M270 170v36c0 18.778-15.222 34-34 34h-36v-30h30c5.523 0 10-4.477 10-10v-30zm-230 0v30c0 5.523 4.477 10 10 10h30v30H44c-18.778 0-34-15.222-34-34v-36zm164-70a6 6 0 0 1 6 6v68a6 6 0 0 1-6 6H76a6 6 0 0 1-6-6v-68a6 6 0 0 1 6-6zM80 40v30H50c-5.523 0-10 4.477-10 10v30H10V74c0-18.778 15.222-34 34-34zm156 0c18.778 0 34 15.222 34 34v36h-30V80c0-5.523-4.477-10-10-10h-30V40z"
})));
export default SvgExpand;